<router-outlet></router-outlet>
<!-- <ngx-ui-loader
  [fgsType]="spinner.squareJellyBox"
  [fgsSize]="60"
  [fgsColor]="'#EF4444'"
  [pbColor]="'#EF4444'"
  [pbThickness]="5"
  textColor="#EF4444"
></ngx-ui-loader> -->
